import { Injectable } from '@angular/core';

export interface Constants {
    LIMIT_SIZE_MB: 20; //Mb
}

export const STATUS: any[] = [
    { name: 'Aperta', value: 'OPEN' },
    { name: 'Scade', value: 'EXPIRE' },
    { name: 'Concluso', value: 'CLOSE' },
    { name: 'All', value: 'ALL' }
];

